import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const service_types = {
  diy: 't(I want to create, schedule, and post my own social media posts)',
  none: 't(I dont want to use the social media scheduling system)',
  optin: 't(Create social media posts for me)',
  optout: 't(Dont create social media posts for me)'
}

const SocialStrategyToken = ({ value }) => (
  <div className="token">
    <T text={ service_types[value] } />
  </div>
)

SocialStrategyToken.propTypes = {
  value: PropTypes.string
}

export default SocialStrategyToken
